import React from 'react';
import AssessmentAcceleratorActivitiesList from './components/AssessmentAcceleratorActivitiesList';
import { ModuleProps } from 'types';
import useKeyLessonPreview from '../hooks/use-key-lesson-preview';
import useAssessmentAcceleratorPreview from '../hooks/use-assessment-accelerator-preview';
import PreviewListContainer from '../components/PreviewListContainer';
import PreviewListHeaderContainer from '../components/PreviewListHeaderContainer';

const AssessmentAcceleratorPreview: React.FC<ModuleProps> = props => {
  const { gradeLevel } = useKeyLessonPreview();
  const { data } = useAssessmentAcceleratorPreview();

  return (
    <PreviewListContainer {...props}>
      <PreviewListHeaderContainer
        title={data?.keyboardingModules[0].name}
        chip={{ text: `Grade ${gradeLevel}`, backgroundColor: '#16622D' }}
        subtitle={data?.keyboardingModules[0].description}
      />
      {!data ? null : (
        <AssessmentAcceleratorActivitiesList keyboardingModules={data.keyboardingModules} />
      )}
    </PreviewListContainer>
  );
};

export default AssessmentAcceleratorPreview;
